<template>
  <transition-group  name="fade" appear >
    <div class="general-journal__main-container" id="general-journal__main-container" key="main" v-if="showModal">
      <loading
        :can-cancel="false" 
        :is-full-page="false"
        :active.sync="isLoading" >
      </loading>
      <div class="general-journal_header">
        <button class="back-button-container" @click="$emit('onBack')">
          <v-icon name="chevron-left" class="back-icon"/>
          Back
          </button>
        <div class="header-content-container">
          <div class="header-info">
            <div class="header__title ">
              GENERAL JOURNAL ENTRY
            </div>
            <div class="header__sub-title">
              <!-- Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sequi magni at enim, debitis eaque sunt? -->
            </div>
          </div>  
          <div class="header-options">
            <v-icon
              name="sync"
              spin
              v-if="form.isProcessing"
              class="loading-icon">
            </v-icon>
            <b-dropdown boundary="window" right variant="link" toggle-class="text-decoration-none" no-caret>
              <template v-slot:button-content>
                <v-icon name="ellipsis-v" />
              </template>
              <b-dropdown-item
                @click="onSave()">
                Save
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
      <div class="general-journal_content">
        <div class="left-pane">
          <div class="side-nav" >
            <a class="side-nav-item"
              :href="`#${nav.name}`"
              v-for="(nav, idx ) in navOptions" 
              :key="idx" 
              :class="{ active: activeIndex === idx}"
              v-smooth-scroll="{ duration: 500, offset: -130, container: '#general-journal__main-container', updateHistory: false}"
              @click.prevent="onSelectNav(idx)"> {{ nav.header }}</a>
          </div>
        </div>
        <div class="content-pane">
          <div class="content-section">
            <div class="section-item" :id="navOptions[0].name">
              <ActiveViewSectionHeader
                :sectionNumber="1"
                :sectionHeader="navOptions[0].header"
                :sectionSubHeader="navOptions[0].subHeader"  />
              <div class="section-content">
                <div class="client-info__wrapper">
                  <div class="client-info__left">
                    <b-form-group>
                      <label class="required"> TXN #</label>
                      <b-form-input 
                        disabled
                        :value="mode === 'Add' ? 'Auto Generated' : form.fields.referenceNo"/>
                      <b-form-invalid-feedback>
                        {{ form.errors.referenceNo }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group>
                      <div class="client-label__container">
                        <label class="required"> Client</label>
                        <label class="select-link" @click="showClientModal=true">Select Client</label>
                      </div>
                      <b-form-input 
                        :value="form.fields.client ? form.fields.client.name : null"
                        :state="form.states.clientId"
                        disabled />
                      <b-form-invalid-feedback>
                        {{ form.errors.clientId }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div class="client-info__right">
                    <b-form-group>
                      <label class="required"> Date</label>
                      <b-form-datepicker
                        :state="form.states.transactionDate"
                        v-model="form.fields.transactionDate"/>
                      <b-form-invalid-feedback>
                        {{ form.errors.transactionDate }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
            <div class="section-item" :id="navOptions[1].name">
              <ActiveViewSectionHeader
                :sectionNumber="2"
                :sectionHeader="navOptions[1].header"
                :sectionSubHeader="navOptions[1].subHeader"  />
              <div class="section-content">
                <div class="account-titles__wrapper" ref="accountTitlesWrapper">
                  <CustomTable
                    :table="tables.accountTitles"
                    isOtherItems
                    :items="form.fields.accountTitles">
                    <template v-slot:cell(id)="{ item }">
                      <v-select
                        :options="options.accountTitles.items"
                        label="name"
                        :disabled="options.accountTitles.isBusy"
                        v-model="item.id"
                        :reduce="accountTitle => accountTitle.id"
                        :loading="options.accountTitles.isBusy"
                        appendToBody
                      >
                        <template #spinner="{ loading }">
                          <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner" />
                        </template>
                      </v-select>
                    </template>
                    <template v-slot:cell(pivot.memo)="{ item }">
                      <b-form-input
                        v-model="item.pivot.memo">
                      </b-form-input>
                    </template>
                    <template v-slot:cell(pivot.debit)="{ item }">
                      <v-autonumeric
                        class="form-control text-right"
                        v-model="item.pivot.debit"
                        :options="{
                          minimumValue: '0',
                          modifyValueOnWheel: false,
                          emptyInputBehavior: 0
                        }"/>
                    </template>
                    <template v-slot:cell(pivot.credit)="{ item }">
                      <v-autonumeric
                        class="form-control text-right"
                        v-model="item.pivot.credit"
                        :options="{
                          minimumValue: '0',
                          modifyValueOnWheel: false,
                          emptyInputBehavior: 0
                        }"/>
                    </template>
                    <template v-slot:cell(action)="{index}">
                      <div class="text-center">
                        <b-button
                          size="sm"
                          variant="outline-success"
                          @click="onAddAccountTitle(index)">
                          <v-icon name="plus-circle"/>
                        </b-button>
                        <b-button
                          v-if="form.fields.accountTitles.length > 1"
                          size="sm"
                          class="ml-1"
                          variant="outline-danger"
                          @click="onRemoveAccountTitle(index)">
                          <v-icon name="trash"/>
                        </b-button>
                      </div>
                    </template>
                    <template #custom-foot>
                      <b-tr>
                        <b-td colspan=2 style="border: none">
                          <div class="text-right font-weight-bold">Total :</div>
                        </b-td>
                        <b-td style="border: none">
                          <div class="text-right font-weight-bold">{{ $options.formatNumber(totalDebit) }}</div>
                        </b-td>
                        <b-td style="border: none">
                          <div class="text-right font-weight-bold">{{ $options.formatNumber(totalCredit) }}</div>
                        </b-td>
                      </b-tr>
                    </template>
                  </CustomTable>
                  <b-form-group 
                    :state="form.states.accountTitles"
                    :invalid-feedback="form.errors.accountTitles"/>
                </div>
              </div>
            </div>
          </div>
          <div class="content_footer">
            <SaveButton @click="onSave()" :isProcessing="form.isProcessing"/>
            <CloseButton @click="$emit('onBack')" class="ml-2" :isProcessing="form.isProcessing"/>
          </div>
        </div>
        <!-- <div class="right-pane">
          <div class="summary-wrapper">
            <div class="summary-group">
              <div class="summary-label">TOTAL AMOUNT</div>
              <div class="summary-amount">{{ $options.formatNumber(totalAmount) }}</div>
            </div>
          </div>
        </div> -->
      </div>

      <ClientsModal
        @clickClient="onSelectClient($event)"
        @close="showClientModal = false"
        :show="showClientModal"/>
    </div>
  </transition-group>
</template>

<script>
import {
  ActiveViewSectionHeader,
  CustomTable,
  CustomModal,
  SaveButton,
  CloseButton,
  SearchBar,
  CustomPagination,
  ChargesModal,
  ClientsModal,
  ContractHistoryModal } from "../../components";
import CustomToolTip from '../../components/CustomToolTip'
import Folder from '../../../assets/svg/Folder.svg'
import AddFile from '../../../assets/svg/AddFile.svg'
import { formatNumber, showNotification } from '../../../helpers/forms'
import { ContractStatuses } from "../../../helpers/enum";
import { createPopper } from '@popperjs/core';
import { format } from 'date-fns'
import ContractOptionItem from '../../components/ContractOptionItem'
import { AccountTitleApi } from '../../../mixins/api';

export default {
  format,
  formatNumber,
  ContractStatuses,
  components: {
    ActiveViewSectionHeader,
    CustomTable,
    Folder,
    AddFile,
    CustomModal,
    SaveButton,
    CloseButton,
    SearchBar,
    CustomPagination,
    CustomToolTip,
    ChargesModal,
    ClientsModal,
    ContractOptionItem,
    ContractHistoryModal
  },
  props: {
    form: Object,
    show: Boolean,
    mode: {
      type: String,
      default: 'Add'
    },
    billingId: {
      type: Number,
      default: null
    },
    monthId: Number,
    year: Number,
  },
  mixins: [ AccountTitleApi ],
  data() {
    return {
      isLoading: false,
      activeIndex: 0,
      showClientModal: false,
      placement: 'bottom',
      selectedClient: {
        id: null,
        name: null,
      },
      navOptions: [
        {
          name: 'generalJournalInfo',
          header: 'Information',
          subHeader: ''
        },
        {
          name: 'accountTitles',
          header: 'Journal Entries',
          subHeader: ''
        },
      ],
      tables: {
        accountTitles: {
          isBusy: false,
          fields: [
            {
              key: 'id',
              label: 'Account Title',
              thClass: 'align-middle',
              tdClass: 'align-middle',
              thStyle: {width: '20%'}
            },
            {
              key: 'pivot.memo',
              label: 'Memo',
              thClass: 'align-middle',
              tdClass: 'align-middle',
              thStyle: {width: 'auto'}
            },
            {
              key: 'pivot.debit',
              label: 'Dr',
              thClass: 'align-middle text-right',
              tdClass: 'align-middle text-right',
              thStyle: {width: '20%'}
            },
            {
              key: 'pivot.credit',
              label: 'Cr',
              thClass: 'align-middle text-right',
              tdClass: 'align-middle text-right',
              thStyle: {width: '20%'}
            },
            {
              key: 'action',
              label: '',
              thClass: 'align-middle',
              tdClass: 'align-middle',
              thStyle: {width: '100px'}
            },
          ],
          items: []
        }
      },
      options: {
        accountTitles: {
          isBusy: false,
          items: []
        },
      },
    }
  },
  created() {
    this.loadAccountTitles();
  },
  methods: {
    onSelectNav(idx) {
      this.activeIndex = idx
    },
    loadAccountTitles() {
      const { accountTitles } = this.options
      const params = { paginate: false }
      accountTitles.isBusy = true
      this.getAccountTitleList(params).then(({ data }) => {
        accountTitles.items = data
        accountTitles.isBusy = false
      })
    },
    onAddAccountTitle() {
      const { accountTitles } = this.form.fields
      accountTitles.push({
        id: null,
        pivot: {
          memo: '',
          debit: 0,
          credit: 0
        }
      })
    },
    onRemoveAccountTitle(index) {
      const { fields } = this.form
      fields.accountTitles.splice(index, 1)
    },
    onSelectClient(client) {
      const { fields } = this.form
      fields.clientId = client.id
      fields.client = client
      this.showClientModal = false
    },
    onSave() {
      const { accountTitles } = this.form.fields
      if (accountTitles.find(a => a.id === null)) {
        showNotification(this, 'danger', 'All journal entries must have an account title.')
        return
      }

      if (this.totalDebit !== this.totalCredit) {
        showNotification(this, 'danger', 'Total debit and credit must be equal.')
        return
      }

      this.$emit('save')
    }
  },
  computed: {
    showModal: {
      get: function() {
        return this.show
      },
      set: function(newValue) {
        return newValue
      }
    },
    totalDebit() {
      const { accountTitles } = this.form.fields
      return accountTitles.reduce((total, item) => total += Number(item.pivot.debit), 0)
    },
    totalCredit() {
      const { accountTitles } = this.form.fields
      return accountTitles.reduce((total, item) => total += Number(item.pivot.credit), 0)
    },
  },
  mounted() {
    const body = document.querySelector('body');
    if (body) {
      body.style.overflow = 'hidden';
    }
  },
  beforeDestroy() {
    const body = document.querySelector('body');
    if (body) {
      body.style.overflow = 'auto';
    }
  },
}
</script>

<style lang="scss">

  .general-journal__main-container {
    width: 100%;
    height: 100vh;
    background-color: white;
    position: fixed;
    top: 0;
    left: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    // overflow-x: hidden;
    z-index: 1030;
  }

  .general-journal_header { 
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    height: 100px;
    background-color: whitesmoke;
    border-bottom: solid 1px lightgray;
    width: calc(100% - 15px);
    z-index: 199;

    .back-button-container {
      width: 200px;
      height: 100%;
      justify-content: center;
      align-items: center;
      border: none;
      font-size: 24pt;

      .back-icon {
        width: 35px;
        height: 35px;
      }

      &:hover {
        background-color: lightgray;
      }
    }

    .header-content-container {
      flex: 1;
      display: flex;
      height: 100%;
      align-items: center;

      .header-info {
        flex: 1;
        height: 100%;
        display: flex;
        justify-content: center;
        padding: 0 20px;
        flex-direction: column;
        height: 100%;
        // border: solid 1px;

        .header__title {
          font-size: 16pt;
          font-weight: bold;
        }

        .header__sub-title {
          font-size: 10pt;
          color: #a19e9e;
        }
      }

      .header-options {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        min-width: 100px;
        height: 100%;
        margin-right: 5px;;

        .loading-icon {
          margin-right: 10px;
        }
      }

      .header-group {
        width: 30%;
        display: flex;
        flex-direction: column
      }

      .header-label {
        font-size: 12pt;
        color: gray;
      }
    }
  }

  .left-pane {
    height: 100%;
    min-width: 200px;
    position: relative;
    padding: 10px;
    border-right: solid 1px lightgray;

    .side-nav {
      padding: 5px;
      display: flex;
      // align-items: center;
      position: sticky;
      top: 110px;
      flex-direction: column;

      .side-nav-item {
        font-size: 10.5pt;
        margin-bottom: 15px;
        padding: 0 5px;
        min-height: 30px;
        display: flex;
        align-items: center;
        text-decoration: none;


        &.active {
          background-color: lightblue;
          color: white;
          font-weight: bold;
          border-radius: 5px;
        }

        &:hover {
          cursor: pointer;
          background-color: lightgray;
        }
      }
    }
  }

  .right-pane {
    height: 100%;
    min-width: 250px;
    background-color: white;
    border-left: solid 1px lightgray;
    padding: 10px;
    position: relative;

    .summary-wrapper {
      display: flex;
      flex-direction: column;
      position: sticky;
      top: 110px;
    }
  }

  .general-journal_content {
    display: flex;
    flex: 1;
    margin-top: 100px;
  }

  .content-pane {
    flex: 1;
    width: 100%;
    height: 100%;
    background-color: white;
    padding: 30px;
    position: relative;

    .content-section {
      margin-bottom: 30px;
      width: 100%;
    }

    .content_footer {
      min-height: 60px;
      justify-content: flex-end;
      align-items: center;
      display: flex;
      background-color: white;
      position: sticky;
      bottom: 0;
      border-top: solid 1px lightgray;
      margin: 0;
    }
  }

  .section-item {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    margin-bottom: 30px;
    
    .section-content {
      width: 100%;
      padding-left: 40px;
      padding-top: 10px;
    }
  }

  .client-info__wrapper {
    display: flex;
    height: auto;
    width: 100%;
    // justify-content: space-between;

    .client-info__left {
      width: 50%;
      display: flex;
      flex-direction: column;
      margin-right: 20px;
    }

    .client-info__right {
      width: 50%;
      display: flex;
      flex-direction: column;
    }
  }

  .account-titles__wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;

    .account-titles__filters {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;

      .account-titles__button {
        width: auto;
      }

      .account-titles__search {
        max-width: 300px;
      }
    }
  }

  .button-footer {
      display: flex;
      width: 100%;
      justify-content: flex-end;
      align-items: center;
  }

  .client-label__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .search-bar__container {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;

    .search-bar {
      max-width: 250px!important;
    }
  }

  /* ---------------------------------- */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .4s linear;
    .billing-header,.billing-content {
      transition: transform 0.35s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.35s linear;
    }
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    .billing-header,.billing-content {
      // opacity: 0;
      transform: scale(0.3) translateY(-50%);
    }
  }
  
  .summary-group {
    margin: 10px 0;
    width: 100%;
    color: rgb(61, 60, 60);

    .summary-label {
      font-size: 12pt;
      font-weight: bold;
      width: 100%;
    }

    .summary-link {
      color: rgb(21, 30, 153);

      &:hover {
        color: rgb(77, 87, 221);
        cursor: pointer;
        text-decoration: underline;
      }
    }

    .summary-amount {
      font-size: 18pt;
      width: 100%;
      font-weight: 500;
      text-align: right;
    }
  }

  .row__sub-label {
    font-size: 8pt!important;
    color: gray!important;
  }

  .v-select .vs__selected-options {
    flex-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  

</style>
